import { useEffect } from 'react';

import useAuthenticatedUser from '../packages/kakapo-ui-application/hooks/useAuthenticatedUser';

export default function Satismeter() {
	const user = useAuthenticatedUser();

	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://app.satismeter.com/js';
		script.onload = () => {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(window as any).satismeter?.({
				writeKey: 'KI8o3j92B89MTh97',
				userId: user.id,
				traits: {
					name: [user.firstName, user.lastName].join(' '),
					email: user.email,
				},
			});
		};
		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.firstName, user.lastName, user.email]);

	return null;
}
